import React, { useRef, useEffect } from "react";
import { withRouter } from "react-router-dom";

const ScrollToTop: React.FC = ({ children }) => {
  const changedLocation = useRef(false);
  useEffect(() => {
    if (changedLocation.current) {
      window.scrollTo(0, 0);
    } else {
      changedLocation.current = true;
    }
  });
  return <div>{children}</div>;
};

export default withRouter(ScrollToTop);
